import { StyleSheet } from 'react-native';

import styled from 'styled-components';
import Layout from '../../config/Layout';
import Colors from '../../config/Colors';

export default StyleSheet.create({
    container: {
        flex: 1
    },
    content: {
        marginTop: 0,
        flex: 1,
        flexDirection: 'row'
    },
    view: {
        flex: 1,
        flexDirection: 'row'
    },
    list: {
        flex: 4,
        maxWidth: 400
    },
    detail: {
        flex: 8
    },
    containerOptions: {
        flex: 1,
        paddingTop: Layout.statusBar,
        borderRightWidth: 1,
        borderRightColor: Colors.border
    },
    itemList: {
        paddingVertical: 14,
        paddingHorizontal: Layout.gutter,
        flexDirection: 'column',
        borderBottomWidth: 1,
        borderBottomColor: Colors.border
    },
    lineContent: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginVertical: Layout.gutterMin
    },
    itemTitle: {
        fontSize: 18,
        fontFamily: 'NunitoSans-Bold'
    },
    itemSubtitle: {
        color: '#000000',
        fontSize: 16,
        opacity: 0.5
    },
    hfContainer: {
        padding: 16
    },
    hfTitle: {
        paddingBottom: 16
    },
    row: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    lineSpacing: {
        paddingBottom: 12
    },
    hrButton: {
        backgroundColor: '#F5F5F5',
        padding: 4,
        borderColor: '#E3E3E3',
        borderRadius: 6,
        borderWidth: 1
    },
    hrButtonTitle: {
        color: '#515151'
    }
});

export const Tab = styled.button`
    border: none;
    background-color: ${Colors.white};
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    align-items: center;
    min-width: 140px;

    border-bottom: ${({ isSelected }) =>
        isSelected && `2px solid ${Colors.blue_button}`};

    &:hover {
        background-color: ${Colors.lightBlue};
        cursor: pointer;
    }
`;

export const TabText = styled.span`
    color: ${Colors.dark};
    font-family: ${({ isSelected }) =>
        isSelected ? 'NunitoSans-Bold;' : 'NunitoSans-Regular;'};
    font-size: 1.6rem;
    margin-bottom: 3px;
    margin-left: 0;

    ${({ isSelected }) =>
        isSelected ? `color: ${Colors.blue_button}; font-weight: bold;` : null}
`;

export const Header = styled.header`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    border-bottom: 1px solid ${Colors.border};
    background-color: ${Colors.white};
    padding: 0 25px 0 25px;
    min-height: 65px;
    position: sticky;
    top: 0;
    z-index: 100;
`;

export const HeaderTitle = styled.h1`
    display: flex;
    font-family: NunitoSans-Bold;
    font-size: 2rem;
`;

export const SectionTitles = styled.strong`
    font-family: NunitoSans-Bold;
    font-size: 1.8rem;
    margin: 32px 0 16px 0;
`;

export const RadioInput = styled.input.attrs({
    type: 'radio'
})`
    margin: 0 10px 0 0;
    height: 20px;
    width: 20px;
    &:hover {
        cursor: pointer;
    }
`;

export const RadioRow = styled.div`
    display: flex;
    padding-left: 0;
    align-items: center;
    background-color: ${Colors.white};
    border: none;
    flex-direction: row;
    cursor: pointer;
    width: fit-content;
    margin-bottom: 16px;
    font-family: NunitoSans-Regular;
    font-size: 1.6rem;
`;

export const Descricao = styled.label`
    color: ${Colors.black};
    font-family: NunitoSans-Regular;
    font-size: 1.4rem;
    margin-bottom: 3px;
    margin-left: 0;
    opacity: 0.8;
`;

export const ButtonContainer = styled.div`
    margin-top: 25px;
    display: flex;
    align-self: flex-start;
    max-width: 230px;
`;
